import { Currency } from "./currency";
import { EwaybillAttachedDocumentsForm } from "@app/user/documents/ewaybill/ewaybill/ewaybill-attached-documents/ewaybill-attached-documents.component";
import { ExtraFieldForm } from "@app/user/documents/ewaybill/ewaybill/ewaybill-extra-information/ewaybill-extra-information.component";
import { Country } from "./countries";
import { UnitOfMeasure } from "./unit-of-measures";
import { MessageType } from "./documents";
import { DocumentSignature, Signature } from "./signature";
import { Status } from "./status";
import { IdWithName } from "@app/user/marks/marks-store/marks-types";
import { TotalSums } from "@app/user/documents/ewaybill/ewaybill";
import { FieldCostControlDto } from "./eact";
import { CustomCodeSet } from "@app/user/documents/ewaybill/service/product-popup.service";
import { ClaimsDTO } from "./yandex-delivery";
import { TransinetPerformerInfo } from "./transinet";

export interface EwaybillResponse extends Ewaybill {
	msgEwaybill: Ewaybill;
}

export interface Ewaybill extends Partial<DocumentSignature> {
	formType?: number;
	changeRequestList?: ChangeRequestEwaybillDocument[];
	changeRequestDocument?: ChangeRequestEwaybillDocument;
	cancellable?: boolean;
	certificate?: string;
	creationDateTime?: Date;
	confirmation?: any;
	certificateUserName?: string;
	signatureDate?: Date;
	documentNumber?: string;
	signatureTime?: string;
	cancelDocument?: {
		confirmation: DocumentSignature;
		deliveryError: string;
		deliveryStatus: number;
		id: number;
		signature: Signature;
	};
	readMsgReceiver?: boolean; //Признак прочтения документа
	readMsgSender?: boolean; //Признак прочтения документа
	responseDocument?: DocumentSignature;
	testIndicator: boolean; // Тестовая
	processingStatus?: string; // Статус
	deliveryNoteNumber: string; // Серия // Номер
	deliveryNoteDate?: string; // Дата создания(дата)
	ordersNumber?: string; // Номер заказа
	contractNumber?: string; // Основание отпуска номер
	contractDate?: string; // Основание отпуска дата
	contractName?: string; // Основание отпуска наименование
	currency?: Currency; // Валюта
	number?: string; // Номер черновика
	expireDate?: Date;

	// Грузоотправитель
	shipperGln?: string; // Грузоотправитель GLN
	shipperId?: number; // Грузоотправитель ID
	shipperName?: string; // Грузоотправитель наименование
	shipperAddress?: string; // Грузоотправитель адрес
	shipperUnp?: string; // Грузоотправитель УНП
	shipperProviderId?: string;

	// Грузополучатель
	receiverGln?: string; // Грузополучатель GLN
	receiverId?: number; // Грузополучатель ID
	receiverName?: string; // Грузополучатель наименование
	receiverAddress?: string; // Грузополучатель адрес
	receiverUnp?: string; // Грузополучатель УНП
	receiverProviderId?: string;
	receiverInternal?: boolean;

	// Заказчик
	freightPayerGln?: string; // Заказчик GLN
	freightPayerId?: number; // Заказчик ID
	freightPayerName?: string; // Заказчик наименование
	freightPayerUnp?: string; // Заказчик адрес

	// Место погрузки
	shipFrom?: EwaybillShipper;

	// Место разгрузки
	shipTo?: EwaybillShipper;

	// Транспортные реквизиты
	transportNumber?: string; // Марка и номер авто
	trailerNumber?: string; // Марка и номер прицепа
	waybillNumber?: string; // К путевому листу №
	transportOwnerName?: string; // Владелец транспорта
	transportContact?: string; // ФИО водителя
	quantityTrip?: string; // кол-во заездов (maybe number?)

	// Реквизиты ответственных лиц
	shipperContact?: string; // Отпуск разрешил
	shipFromContact?: string; // Сдал грузоотправитель
	shipperSealNumber?: string; // № пломбы
	deliveryContact?: string; // Товар к перевозке принял
	proxyDate?: string; // По доверенности(дата)
	proxyNumber?: string; // По доверенности(номер)
	partyIssuingProxyName?: string; // Название организации, выдавшей доверенность
	baseShippingDocumentName?: string; // Основание доставки(наименование) only for TN
	baseShippingDocumentNumber?: string; // Основание доставки(номер) only for TN
	baseShippingDocumentDate?: Date; // Основание доставки(дата) only for TN

	// С товаром переданы документы
	msgEwaybillDocList?: EwaybillAttachedDocumentsForm[];

	// Дополнительные поля
	msgEwaybillExtraFieldList?: ExtraFieldForm[];
	msgEwaybillResponseActDtoList?: any[];

	//Принял грузополучатель
	receiverSealNumber?: string; //№ пломбы

	//Отметки о составленных актах
	reportName?: string; //Наименование
	reportID?: string; //Номер
	reportDate?: string; //Дата
	msgEwaybill?: Ewaybill;
	markCode?: boolean;
	markCodeVerification?: boolean;
	msgEwaybillProductList: EwaybillProduct[];
	totalAmountExcise?: string;
	totalAmountVat?: string;
	totalAmountWithVat?: string;
	totalAmountWithoutVat?: string;
	totalGrossWeight?: string;
	totalLine?: number;
	totalQuantity?: string;
	totalQuantityLu?: string;
	functionCode?: number;
	msgReceiverGln?: string;
	msgReceiverId?: number;
	msgSenderGln?: string;
	msgSenderId?: number;
	deliveryNoteType?: string;
	msgType?: MessageType;
	documentDate?: string;
	shipperCountryName?: string;
	receiverCountryName?: string;
	transporterName?: string;
	transporterGln?: string;
	transporterUnp?: string;
	cancelDeliveryNoteID?: string;
	version?: string | number;
	deliveryError?: string;
	blrapnDesc?: string;
	dateCreate?: Date;
	freightPayerAddress?: string;
	deliveryStatus?: number;
	formSettings?: {
		isPublicGlnAtShipTo?: boolean;
		isPublicGlnAtShipFrom?: boolean;
		isAutoSum: boolean;
		productsPositionWithAutoSum: boolean[];
		productsWhereMarksSelectedFromList?: number[];
		ewaybillMilk?: EwaybillMilk;
	};
	deliverySystemData?: DeliverySystemDataDto;
	blockForm?: boolean;
	deliverySystemType?: Status;
}

export interface DeliverySystemDataDto {
	actual?: boolean;
    claimId?: string;
    errorMessage?: string;
    id?: number;
    rawClaim?: ClaimsDTO;
    status?: Status;
    rawClaimResponse?: TransinetPerformerInfo;
}

export interface EwaybillMilk {
	loading: [{
		address: string;
		isPublic: boolean;
		gln: string;
		id: number | string;
		name: string;
		contact: string;
	}] | any;
	purchaseType: any;
	sealedGood: any;
	garageNumber: string;
	productAnalysis: string;
	routerNumber: string;
	startDateLoading: Date;
	endDateLoading: Date;
	transportationType: any;
	msgEwaybillProductList: {
		products: EwaybillMilkProduct[];
		totalSums: TotalSums;
	};
}

export interface EwaybillShipper {
	id?: number;
	gln?: string;
	address?: string;
	contact?: string;
	name?: string;
	isPublic?: boolean;
	receiverInternal?: boolean;
	storageName?: string;
}

export interface EwaybillReceived extends Ewaybill {
	msgNumber: string;
	msgDate: Date;
	documentNumber: string;
	creationDateTime: Date;
	userId: number;
}

export interface ChangeRequestEwaybillDocument extends DocumentSignature {
	changeReason: string;
}

export interface EwaybillMilkProduct {
	itemType: string;
	position: number;
	gtin: string;
	codeByBuyer: string;
	codeBySupplier: string;
	fullName: string;
	priceNet: number;
	uom: UnitOfMeasure; // Единица измерения
	quantityDespatchLu: number; // Кол-во мест, шт
	MWF012: string;
	MWF001: string;
	MWF002:  string;
	MWF003:  string;
	MWF004:  string;
	MWF005:  string;
	MWF006:  string;
	MWF007:  string;
	MWF008:  string;
	MWF009:  string;
	MWF010:  string;
	MWF011:  string;
	grossWeight:  number;
	quantityDespatch:  number;
	vatRate: number | string;
	isWithoutVatRate: boolean;
	addInfo: string;
	msgEwaybillExtraFieldList: ExtraFieldForm[];
	amountVat: number;
	amountWithVat: number;
	amountWithoutVat: number;
	autoSum: boolean;
	fieldCostControlDto?: FieldCostControlDto;
}

export interface EwaybillProduct {
	position: number; // Позиция товара в списке
	gtin: string; // GTIN
	codeByBuyer: string; // Номер товара, приcвоеный покупателем
	codeBySupplier: string; // Номер товара, приcвоеный продавцом
	fullName: string; // Наименование товара
	uom: UnitOfMeasure; // Единица измерения
	quantityDespatch: number; // Количество
	priceNet: number; // Цена 
	priceManufacturer: number; // Цена изготовителя
	discountBulkRate: number; // Оптовая скидка
	discountRate: number; // Скидка, %
	vatRate: number | string; // Ставка, НДС
	isWithoutVatRate?: boolean;
	amountExcise: number; //Сумма акциза
	quantityDespatchLu: number; // Количество грузовых мест
	grossWeight: number; // Масса груза, тонны
	countryOfOrigin: Country; // Страна производства
	bestBeforeDate: string; // Срок реализации
	addInfo: string; // Примечание
	msgEwaybillItemCertList: ProductDocumentInformation[]; // Информация о документе
	msgEwaybillExtraFieldList: ExtraFieldForm[]; // Дополнительные поля
	amountVat: number; // Cтоимость
	amountWithVat: number; // Сумма НДС
	amountWithoutVat: number; // Сумма с НДС

	itemType: string;
	productTraceabilityDataDto: ProductTraceabilityData;
	receiptDocumentDto: ReceiptDocument;

	markCodeSet: MarkCode[];
	marksType?: string;
	fieldCostControlDto?: FieldCostControlDto;
	partyNumber?: string; // TODO deprecated Номер партии
	productDate?: string; // TODO deprecated Дата производства
	markCodeList?: any[]; // TODO type
	customCodeOther?: string | CustomCodeSet;
	aggregationCodeList?: any[];  // TODO type
}

export interface MarkCode {
	markCodeSet: MarkCode[];
	markCodeType?: IdWithName;
	markCodeValue: string;
	comment?: string;
	dateCreate?: string;
	group?: {
		code?: string;
		name?: string;
	};
	gtin?: string;
	gtinDetails?: {
		additionalProp1?: number;
		additionalProp2?: number;
		additionalProp3?: number;
	};
	hasParent?: boolean;
	id?: number | string;
	itemInfo?: ItemInfo;
	itemName?: string;
	lineNumber?: number;
	orderNumber?: number;
	status?: IdWithName;
	parentId?: string;
}

export interface ItemInfo {
	description?: string;
	markParams?: ParamDto[];
	name?: string;
	params?: ParamDto[];
}

export interface ParamDto {
	code?: number;
	displayValue?: string;
	name?: string;
	value?: string;
}

export interface ProductTraceabilityData {
	customCode: string; //Код ТНВЭД товара
	partyNumber?: string; // TODO deprecated Номер партии
	productDate?: string; // TODO deprecated Дата производства
	priceSPT?: string;
	quantityDespatchedSPT?: string; //Отгруженное количество товара в количественных единицах измерения товара, используемых для осуществления прослеживаемости
	quantitySPT?: {
		alpha3: string;
		id: number;
		name: string;
	};
	isValidate?: boolean;
	customCodeOther?: string | CustomCodeSet;
	isTraceable?: boolean;
}

export interface ReceiptDocument {
	documentDate: Date;
	documentLineNumber: number;
	documentNumber: string;
	documentType: {
		code: string;
		id: number;
		name: string;
	};
}

export interface ProductDocumentInformation {
	certType: { id: string; code: string; nameFull: string; nameShort: string }; // Название
	certNumber: string; // Номер
	dateFrom: string; // Дата с
	dateTo: string; // Дата до
	certPartyIssuingName: string; // Кем выдан
	certPartyNumber: string; //Внесенный в документ номер партии
	certProductDate: string; //Внесенная в документ дата производства
}

export interface ResponseDraftInfo {
	id: number;
	processingStatus: Status;
}

export interface VerificationReportDto {
	positionError: PositionError[];
	totalCount: number;
	verifiedCount: number;
	notVerifiedCount: number;
}

export interface PositionError {
	position: string;
	name: string;
	gtin: string;
    notVerifiedCount: number;
	totalCount: number;
	errorMarkCodeSet: string[];
}

export interface DatamarkFileImportReport {
	dataMarkCount: number;
	failedStringCount: number;
	isDuplicatesRemoved: boolean;
	notFoundGtinList: string[];
	quantityDespatchMismatchPositionList: string[];
}

export type FormType = Array<[{id: string, name: string}, string, string[]?]>;

export const EwaybillFormTypeValues: FormType = [
	[{ id: "0", name: $localize`Типовая` }, $localize`Типовая`],
	[{ id: "1", name: $localize`Факторинг` }, $localize`Факторинг`, ["CTT"]],
	[{ id: "2", name: $localize`Молоко` }, $localize`Молоко`, ["CTT"]],
	[{ id: "3", name: $localize`Экспортная` }, $localize`Экспортная`],
	[{ id: "4", name: $localize`Иной документ` }, $localize`Иной документ`],
];
